// extracted by mini-css-extract-plugin
module.exports = {"root":"Breadcrumb_root__bRdcl","item":"Breadcrumb_item__SCUEW","separator":"Breadcrumb_separator__KXuc7"};